module.exports = __webpack_public_path__ + "img/gold.93ca7763.svg";